// extracted by mini-css-extract-plugin
export default {"root":"_2SEbv","link":"_10M6e","active":"_2ko-S"};